/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Text_LabelInputs */



/**
* | output |
* | --- |
* | "Text" |
*
* @param {Paste_Attributes_Text_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_text_label = /** @type {((inputs?: Paste_Attributes_Text_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Text_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("文章")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मूलपाठ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto")
	return /** @type {LocalizedString} */ ("Text")
});